import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router";
import useAuth from "@/hooks/auth.hook";
import usePlanFeatures from "@/hooks/plan.hook";
import { moduleForPath } from "@/utils/modules";

/**
 * Route-level access guard. Complements the sidebar filter (which only removes links) so typing a
 * URL can't reach a forbidden page:
 *   - /dashboard/manage/* is super-admin only (the backend also rejects these APIs).
 *   - a module a super-admin has hidden for the business is blocked (isModuleVisible).
 * Super-admins bypass both. Renders nothing.
 */
const ModuleRouteGuard = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { isSuperAdmin } = useAuth();
  const { hiddenModules, isModuleVisible } = usePlanFeatures();

  useEffect(() => {
    // Management area is super-admin only.
    if (!isSuperAdmin && location.pathname.startsWith("/dashboard/manage")) {
      navigate("/dashboard", { replace: true });
      return;
    }
    const key = moduleForPath(location.pathname);
    if (key && !isModuleVisible(key)) {
      navigate("/dashboard", { replace: true });
    }
    // isModuleVisible is derived from hiddenModules; depend on its serialized form for stability.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, hiddenModules.join(","), isSuperAdmin, navigate]);

  return null;
};

export default ModuleRouteGuard;
